import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  uploadContent: {
    height: '72px',
    width: '72px',
    display: 'inline-block',
    zIndex: '1',
    position: 'relative',
    '&:hover': {
      '& .uploadIcon': {
        display: 'flex!important',
        opacity: '1!important',
      },
    },
    '& .MuiInputBase-root': {
      height: '72px',
      width: '72px',
      border: '1px dashed #6C59E6',
      borderRadius: '8px',
      cursor: 'pointer',
      '&:hover fieldset': {
        cursor: 'pointer',
      },
      '& fieldset': {
        border: 'unset',
      },
      '& input': {
        display: 'none',
      },
    },
  },
  uploadIcon: {
    position: 'absolute',
    right: '-7px',
    top: '3px',
    cursor: 'pointer',
    color: '#6C59E6',
    borderRadius: '50%',
    backgroundColor: '#ccc',
    width: '15px',
    height: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '15px',
    },
  },
}));
